import React from 'react';
import { Grid2 } from '@mui/material';
import { LazyLoadContainer, Text, V2Button } from '@web-for-marketing/react-ui';
import { Author } from '@models/author';
import { useStaticValues } from '@stateManagement/StaticValuesContext';
import { ensureInternalURLTrailingSlash } from '@helpers/string';
import { useAtom } from 'jotai';
import { selectedLanguageAtom } from '@atoms/appSettings';
import { getLanguageRouteAndPrefixByCodeAndRouteKey } from '@helpers/languages';
import { languageRouteTypes } from '@helpers/languageRoutes';

const classes = {
    media: {
        borderRadius: '50%',
        width: '8rem',
        height: '8rem',
        marginRight: '3.2rem',
        objectFit: 'cover',
    },
    authorContainer: {
        margin: '3.2rem 0',
    },
} as const;

interface AuthorCardV2Props {
    author: Author;
    isBlogPostVisible: boolean;
}

export const AuthorCardV2 = ({ author, isBlogPostVisible }: AuthorCardV2Props): JSX.Element => {
    const { prefixStringWithBaseUrl } = useStaticValues();
    const [selectedLanguage] = useAtom(selectedLanguageAtom);

    return (
        <LazyLoadContainer>
            <Grid2 container flexWrap='nowrap' css={classes.authorContainer}>
                <img alt={author.name} src='' css={classes.media} data-src={prefixStringWithBaseUrl(author.image)} />
                <Grid2>
                    {isBlogPostVisible ? (
                        <V2Button
                            variant='link'
                            component='a'
                            href={ensureInternalURLTrailingSlash(
                                `${getLanguageRouteAndPrefixByCodeAndRouteKey(
                                    selectedLanguage,
                                    languageRouteTypes.AUTHOR
                                )}${author.slug}`
                            )}
                            aria-label={`View ${author.name}'s profile`}
                        >
                            {author.name}
                        </V2Button>
                    ) : (
                        <Text variant='body2' color='activePrimary'>
                            {author.name}
                        </Text>
                    )}
                    <Text css={{ marginTop: '8px' }} variant='body2' color='secondary'>
                        {author.shortBiography}
                    </Text>
                </Grid2>
            </Grid2>
        </LazyLoadContainer>
    );
};
